<style lang="stylus">
    .files-item
        position relative
        width 200px
        height 176px
        margin-right 24px
        margin-bottom 24px
        text-align center
        font-size 13px
        cursor pointer
        user-select none
        border-radius 6px
        border 1px solid transparent
        &.fitheight
            height auto !important
        &.isTeamsApp
            @media screen and (max-width: 500px)
                margin-right 12px
                margin-bottom 12px
        &:hover
            box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04), 0px 6px 15px rgba(0, 0, 0, 0.08);
            .menu-box:not(.saveState)
                display flex
            .filesitem-select-grid,.pcview-select-grid
                display flex
            .filesitem-notes
                display block
            // 非“云文件”tab仅展示“已星标”状态
            .grid-star:not(.readonly)
                display block !important
            // 鼠标hover时，隐藏tag（子组件）
            .filesitem-viewonly
                display none !important
            .filesitem-onlyviewcover
                display flex !important
        &.pcviewgrid:hover
            box-shadow none
            border-color #017fff

        >img
            width 196px
            height 140px
            padding 6px
            object-fit contain
            pointer-events none
            border-radius 6px

        .file-path
            text-align left
            font-size 12px
            margin-top 8px
            color #a2a2a2
            -webkit-line-clamp 2
            overflow hidden
            -webkit-box-orient vertical
            display -webkit-box

        .grid-titlebox
            display flex
            position absolute
            bottom 0
            right 0
            width 100%
            height 36px
            line-height 36px
            gird_titlebar()
            background-color #fafaff
            justify-content space-between
            padding 0 12px
            border-bottom-left-radius 6px
            border-bottom-right-radius 6px
            .titlebox-text
                flex 0 1 auto
                text-align left
                width 100%
                min-width 0
                .ivu-tooltip-rel
                    width 100%
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    line-height 16px

            .titlebox-icons
                flex 0 0 auto
                display flex
                align-items center
                svg
                    padding 4px
                    height 24px
                    width 24px
                .grid-star
                    stroke #9d9d9d
                    fill none
                    &:not(.active):hover
                        stroke #ffc800
                        fill none
                    &.active
                        stroke #ffc800
                        fill #ffc800
            // tooltip 样式跟随设计稿
            .ivu-tooltip-popper
                .ivu-tooltip-arrow
                    display none
                .ivu-tooltip-inner
                    min-height 24px
                    border-radius 6px
                    padding 4px 8px
                    background var(--bg-color-tips)
                    backdrop-filter blur(2px)
                    white-space pre-wrap
                    word-break break-word
        .menu-box
            display flex
            z-index 2
            position absolute
            top 8px
            right 8px
            &.pcview-menu-box
                display none
                top 12px
                right 14px
            .wide-menu-right
                width 90px !important;
            .short-menu-right
                width 30px !important;
            .menu-right
                width 52px
                display flex
                justify-content space-between
                align-items center
                >svg
                    width 24px
                    height 24px
                    fill #a7a7a7
                    box-shadow 0px 2px 5px rgba(0, 0, 0, 0.05)
                    border-radius 4px
                    opacity 0.9
                    backdrop-filter blur(2px)
                    use
                        pointer-events none
                    &:hover
                        fill #222
                .pcview-icon
                    width 24px
                    height 24px
                    border-radius 4px
                    background rgba(0, 0, 0, 0.06)
                    cursor pointer
                    &.pcview-icon-edit
                        background #fff
                        &:hover
                            background #EBF5FF
                    svg
                        width 24px
                        height 24px
                        color #222
                    &:hover
                        background rgba(1, 127, 255, 0.10)
                        svg
                            color #017fff


    .file-item-drag
        opacity .2
    .dark-theme__grid
        .grid-titlebox
            background #343437 !important
            .titlebox-text
                color #fff
    .dark-theme__pcviewgrid
        background rgba(255, 255, 255, 0.08) !important
        .titlebox-text
            color #E6E6E6 !important
</style>
<template>
    <div
        class="files-item"
        :class="{
            'grid-item-active': fileSelected.includes(index),
            'pcsaveinput-active': pcSaveInput,
            pcviewgrid: isNewPcView,
            'dark-theme__grid': isPCDarkMode == 2 && !isNewPcView,
            'dark-theme__pcviewgrid': isPCDarkMode == 2 && isNewPcView,
            isTeamsApp: isTeamsApp,
            fitheight: mode === 'search',
        }"
        :data-index="index"
        :key="index"
        @contextmenu.prevent.stop="
            contextmenu($event, file, index);
            contextmenuEvent();
        "
        @click.exact="gridFileClickEvent(index, file)"
        @click.ctrl.exact="ctrlSelect(index)"
        @dblclick="!mulSelectMode && openFiles(file)"
    >
        <gridFileExpand
            v-if="file.info && ['files', 'openRecord', 'recycle', 'star', 'publishFile'].includes(type)"
            :fileIndex="index"
            :fileSelected="fileSelected"
            :fileTagStr="fileTagStr(file.info.custom_tag)"
            :type="type"
            :edit="file.info && file.info.edit"
            :pcSaveInput="pcSaveInput"
            :remainTime="file.remain_time"
            @selectEvent="selectEvent"
            @expandTag="expandTag()"
            @expandCustomTag="expandCustomTag()"
            @changeTagStr="changeTagStr"
        />
        <img style="background: white" :src="fileImg" @error="coverError($event)" />
        <div v-if="mode === 'search'" class="file-path">{{ $t("path") }}：{{ file.filePath }}</div>
        <div class="grid-titlebox">
            <Tooltip :content="fileName" :delay="500" :max-width="172" placement="bottom-start" class="titlebox-text">
                <p class="file-text" v-if="searchFileName">
                    <span v-for="item in searchFileName" :class="{ 'search-text-highlight': item == searchKey }">{{ item }}</span>
                </p>
                <span class="file-text" v-else>{{ fileName }}</span>
            </Tooltip>
            <div class="titlebox-icons">
                <iconSymbol
                    v-if="file.info && type !== 'recycle' && !pcSaveInput"
                    v-show="!!this.file.info.start_tag"
                    class="grid-star"
                    :class="{ active: file.info.start_tag == 1, readonly: type != 'files' }"
                    name="filesitem-star"
                    :title="starTooltip"
                    @click.stop.native="setStarFile(file)"
                    @dblclick.stop.native=""
                />
                <iconSymbol
                    v-if="filePublish"
                    :style="{ fill: filePublish == 'pass' ? '#017fff' : '#ff8626' }"
                    name="publish-fill"
                    :title="filePublish == 'pass' ? $t('passPublish') : $t('pendingPublish')"
                />
            </div>
        </div>
        <div v-if="type !== 'recycle' && !mulSelectMode" class="menu-box" :class="{ saveState: pcSaveInput, 'pcview-menu-box': isNewPcView }">
            <div
                class="menu-right"
                :class="{
                    'wide-menu-right': type === 'share' && file.code,
                    'short-menu-right': type === 'publishFile',
                }"
            >
                <template v-if="isNewPcView">
                    <div
                        class="pcview-icon"
                        :class="{ 'pcview-icon-edit': file.info && !file.info.edit }"
                        :title="$t('share')"
                        v-if="['files'].includes(type)"
                    >
                        <iconSymbol :name="'pcview-shareIcon'" @click.stop.native="toShare(index, file)" />
                    </div>
                    <div
                        class="pcview-icon"
                        :class="{ 'pcview-icon-edit': file.info && !file.info.edit }"
                        :title="$t('more')"
                        v-if="['publishFile', 'files'].includes(type)"
                    >
                        <iconSymbol :name="'pcview-moreIcon'" @click.stop.native="contextmenu($event, file, index)" />
                    </div>
                </template>
                <template v-else-if="type === 'publishFile'">
                    <iconSymbol :name="'moreFileIcon'" :title="$t('more')" @click.stop.native="contextmenu($event, file, index)" />
                </template>
                <template v-else-if="type === 'files'">
                    <iconSymbol :name="'shareFileIcon'" :title="$t('share')" @click.stop.native="toShare(index, file)" />
                    <iconSymbol
                        :name="'moreFileIcon'"
                        :title="$t('more')"
                        @click.stop.native="contextmenu($event, file, index)"
                        @dblclick.stop.native=""
                    />
                </template>
                <!-- 'share' tab入口已隐藏 -->
                <template v-else-if="type === 'share'">
                    <iconSymbol :name="'copyShareLink'" :title="$t('copyLink')" @click.stop.native="copyLink(index)" />
                    <iconSymbol :name="'cancelShare'" :title="$t('cancelShare')" @click.stop.native="cancelShare(index)" />
                    <iconSymbol v-if="file.code" :name="'showPassCode'" :title="$t('showCode')" @click.stop.native="toShowCode()" />
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
    import fileItem from "./fileItem";
    import gridFileExpand from "./gridFileExpand.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            gridFileExpand,
        },
    })
    export default class gridFile extends Mixins(fileItem) {
        showCode: boolean = false;
        @Prop() cancelShare: any;
        @Prop() copyLink: any;
        @Prop() mulSelectMode: boolean;
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get starTooltip() {
            if (!["files", "star"].includes(this.type)) {
                return this.$t("starFile");
            } else {
                return !!this.file.info.start_tag ? this.$t("cancel") : this.$t("set");
            }
        }
        fileTagStr(tag) {
            // 根据custom_tag返回对应文案
            let list = {
                edraw_0: "tag",
                edraw_1: "waitdone",
                edraw_2: "done",
                edraw_3: "waitchange",
            };
            let str = tag ? this.$t(list[tag]) : this.$t(list["edraw_0"]);
            return str || tag;
        }
        // 初始数据可以直接声明为实例的属性
        toShowCode() {
            this.$store.commit("setState", {
                type: "shareLinkCode",
                data: this.file.code,
            });
            this.$store.commit("setState", {
                type: "showShareCode",
                data: true,
            });
            // this.$nextTick(()=>{
            //     (<HTMLInputElement>this.$refs.codeCon).focus();
            // })
        }
        toShare(index = -1, e) {
            // 国内分享位绑定手机号先绑定手机号

            this.$track("cloudfile", "share");
            if (index != -1) {
                this.selectFile(index);
            }
            this.share(e);
        }
        coverError(e) {
            let lang = this.lang == "zh" ? "zh" : "en";
            e.target.src = require(`@/home/assets/img/files/default-files-${lang}.svg`);
        }
        gridFileClickEvent(index, file = null) {
            if (this.pcSaveInput) {
                this.$emit("changeSaveInputName", this.fileName);
                this.selectFile(index);
                return; // 屏蔽pc保存文件状态
            }
            if (this.mulSelectMode) {
                this.selectFiles(index);
                this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            } else {
                this.openFiles(file);
            }
        }
        ctrlSelect(index) {
            if (this.pcSaveInput) return; // 屏蔽pc保存文件状态
            this.selectFiles(index);
            this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            this.fileSelected.length > 1 && !this.mulSelectMode && this.$emit("enterMulSelectMode");
        }
        selectEvent(index) {
            this.$emit("closeContextmenu");
            if (this.pcSaveInput) return; // 屏蔽pc保存文件状态
            if (!this.mulSelectMode && this.fileSelected[0] == index) {
                // 其他操作下可能有选择单个文件的情景出现
                this.selectFiles(index);
            } else if (!this.mulSelectMode) {
                this.selectFile(index);
                this.$emit("enterMulSelectMode");
            } else {
                this.selectFiles(index);
                this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            }
        }
        closeContextMenu() {
            this.$emit("closeContextmenu");
        }
        expandTag() {
            this.$emit("closeContextmenu");
        }
        expandCustomTag() {
            this.$emit("expandCustomTag");
        }
        changeTagStr(str) {
            this.$emit("setFileItemTagStr", str);
        }
        setStarFile(file) {
            // 仅“云文件”和“星标文件”tab可对星形按钮进行操作
            if (!["files", "star"].includes(this.type)) return;
            this.$emit("setStarFile", file);
        }
        contextmenuEvent() {
            this.$emit("contextmenuEvent");
        }
        get isNewPcView() {
            return this.isPC && this.$isBiggerVersion("13.0.0");
        }
        // mixins for common

        //生命周期
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "open": "打开",
    "path": "路径",
    "tag": "标签",
    "share": "分享",
    "copyLink": "复制链接",
    "cancelShare": "取消分享",
    "showCode": "显示密码",
    "passPublish": "已公开",
    "pendingPublish": "发布中",
    "lockedFile": "文件已加密，请解密后再分享文件",
    "teamEditWarn": "正在编辑该文件",
    "none": "无",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "set": "设置星标",
    "cancel": "取消星标",
    "starFile": "星标文件",
    "more": "更多"
  },
  "de": {
    "open": "Öffnen",
    "path": "Pfad",
    "tag": "Etikette",
    "share": "Teilen ",
    "copyLink": "Link kopieren",
    "cancelShare": "Teilen ausfallen",
    "showCode": "Passwort anzeigen",
    "passPublish": "Öffentlicht",
    "pendingPublish": "Veröffentlicht",
    "lockedFile": "Die Datei ist verschlüsselt. Bitte entschlüsseln Sie sie vor dem Teilen",
    "teamEditWarn": "Diese Datei wird bearbeitet",
    "none": "Nichts",
    "waitdone": "Unfertigt",
    "done": "Gefertigt",
    "waitchange": "Bearbeitbar",
    "set": "Einstellen Sternen",
    "cancel": "Abbrechen Sternen",
    "starFile": "Sternendatei",
    "more": "Mehr"
  },
  "en": {
    "open": "Open",
    "path": "Path",
    "tag": "Tag",
    "share": "Share",
    "copyLink": "Copy link",
    "cancelShare": "Stop sharing",
    "showCode": "Show password",
    "passPublish": "Public",
    "pendingPublish": "Publishing",
    "lockedFile": "The file is encrypted, please decrypt it before sharing",
    "teamEditWarn": "Editing this file",
    "none": "No",
    "waitdone": "In Process",
    "done": "Completed",
    "waitchange": "Need to be modified",
    "set": "Add star",
    "cancel": "Cancel star",
    "starFile": "Starred File",
    "more": "More"
  },
  "es": {
    "open": "Abierto",
    "path": "Camino",
    "tag": "etiqueta",
    "share": "Compartir",
    "copyLink": "Copiar enlace",
    "cancelShare": "Cancelar compartir",
    "showCode": "Mostrar contraseña",
    "passPublish": "Esta publicado",
    "pendingPublish": "Lanzando",
    "lockedFile": "El archivo está cifrado, descifrelo antes de compartirlo",
    "teamEditWarn": "Editando este archivo",
    "none": "Nada",
    "waitdone": "Deshecho",
    "done": "Hecho",
    "waitchange": "Es necesario modificar",
    "set": "Establecer estrella",
    "cancel": "Cancelar estrella",
    "starFile": "Archivo destacado",
    "more": "Más"
  },
  "pt": {
    "open": "Abrir",
    "path": "Caminho",
    "tag": "rótulo",
    "share": "partilhar",
    "copyLink": "copiar ligação",
    "cancelShare": "cancelar partilha",
    "showCode": "mostrar password",
    "passPublish": "Público",
    "pendingPublish": "Anunciando",
    "lockedFile": "O arquivo está criptografado, descriptografe-o antes de compartilhar",
    "teamEditWarn": "Editando este arquivo",
    "none": "nada",
    "waitdone": "incompleto",
    "done": "Concluído",
    "waitchange": "Precisa ser modificado",
    "set": "Definir estrela",
    "cancel": "Cancelar estrela",
    "starFile": "Documentos estrelados",
    "more": "Mais"
  },
  "it": {
    "open": "etichetta",
    "path": "Percorso",
    "tag": "etichetta",
    "share": "Condividi",
    "copyLink": "Copia Collegamento",
    "cancelShare": "Annulla Condivisione",
    "showCode": "Mostra Password",
    "passPublish": "È pubblicato",
    "pendingPublish": "Pubblica in corso",
    "lockedFile": "Il file è crittografato, decrittalo prima di condividerlo",
    "teamEditWarn": "Modifica di questo file",
    "none": "Niente",
    "waitdone": "Incompiuto",
    "done": "Completato",
    "waitchange": "Bisogna modificare",
    "set": "Imposta stella",
    "cancel": "Annulla stella",
    "starFile": "File Stella",
    "more": "Di Più"
  },
  "jp": {
    "open": "開く",
    "path": "パス",
    "tag": "ラベル",
    "share": "共有",
    "copyLink": "リンクをコピー",
    "cancelShare": "共有をキャンセル",
    "showCode": "パスワードを表示",
    "passPublish": "公開済み",
    "pendingPublish": "公開中",
    "lockedFile": "ファイルは暗号化されています。ファイルを共有する前に復号化してください。",
    "teamEditWarn": "ファイルを編集しています。",
    "none": "なし",
    "waitdone": "未完成",
    "done": "完了",
    "waitchange": "修正予定",
    "set": "スターを追加",
    "cancel": "スターを外す",
    "starFile": "スターファイル",
    "more": "もっと"
  },
  "fr": {
    "open": "Allumer",
    "path": "Chemin",
    "tag": "étiqueter",
    "share": "Partager",
    "copyLink": "Copier le lien",
    "cancelShare": "Annuler le partage",
    "showCode": "Montrer le mot de passe",
    "passPublish": "Publique",
    "pendingPublish": "Annoncer",
    "lockedFile": "Le fichier est chiffré, veuillez le déchiffrer avant de le partager",
    "teamEditWarn": "Modifier ce fichier",
    "none": "Rien",
    "waitdone": "Inachevé",
    "done": "Complété",
    "waitchange": "Besoin d'être modifié",
    "set": "Mise en place étoile",
    "cancel": "Annuler étoile",
    "starFile": "Fichier étoile",
    "more": "Plus"
  },
  "tw": {
    "open": "打開",
    "path": "路徑",
    "tag": "標籤",
    "share": "分享",
    "copyLink": "複製連結",
    "cancelShare": "取消分享",
    "showCode": "顯示密碼",
    "passPublish": "已公開",
    "pendingPublish": "發佈中",
    "lockedFile": "檔案已加密，請解密後再分享檔案",
    "teamEditWarn": "正在編輯該檔案",
    "none": "無",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "set": "設置星標",
    "cancel": "取消星標",
    "starFile": "星標檔案",
    "more": "更多"
  },
  "kr": {
    "open": "열기",
    "path": "경로",
    "tag": "태그",
    "share": "공유",
    "copyLink": "링크 복사",
    "cancelShare": "공유 취소",
    "showCode": "암호 표시",
    "passPublish": "공개됨",
    "pendingPublish": "게시 중",
    "lockedFile": "파일이 암호화되어 있습니다. 공유하기 전에 해독하세요~",
    "teamEditWarn": "파일 편집 중입니다.",
    "none": "없음",
    "waitdone": "미완성",
    "done": "완료",
    "waitchange": "수정 필요",
    "set": "즐겨찾기",
    "cancel": "즐겨찾기 취소",
    "starFile": "별표 파일",
    "more": "더보기"
  },
  "id": {
    "open": "Buka",
    "path": "Path",
    "tag": "Tag",
    "share": "Bagikan",
    "copyLink": "Salin tautan",
    "cancelShare": "Berhenti berbagi",
    "showCode": "Tampilkan kata sandi",
    "passPublish": "Publik",
    "pendingPublish": "Menerbitkan",
    "lockedFile": "File dienkripsi. Dekripsikan file sebelum dibagikan",
    "teamEditWarn": "Mengedit file ini",
    "cancel": "Batalkan",
    "waitdone": "Sedang Diproses",
    "done": "Selesai",
    "waitchange": "Perlu dimodifikasi",
    "set": "Tambahkan bintang",
    "cancel": "Batalkan bintang",
    "starFile": "File Berbintang",
    "more": "Lagi"
  }
}
</i18n>
